import config from '../config/config';
import {getExtCustomerId} from './extCustomerId';

class ApiPromise extends Promise {
    constructor(executor) {
        let controller;
        let signal;
        if (window.AbortController) {
            controller = new AbortController();
            signal = controller.signal;
        }
        super((resolve, reject) => {
            return executor(resolve, reject, signal);
        });
        this.controller = controller;
        this.signal = signal;
        // cancelled property, if browser does not support AbortController
        this.cancelled = false;
    }

    cancel() {
        if (this.controller) {
            this.controller.abort();
        }
        this.cancelled = true;
    }

    then(onFulfilled, onRejected) {
        if (config.ENV === 'PRODUCTION') {
            console.clear();
        }
        if (!this.cancelled) {
            return super.then(onFulfilled, onRejected);
        }
    }
    catch(onRejected) {
        if (config.ENV === 'PRODUCTION') {
            console.clear();
        }
        if (!this.cancelled) {
            return super.catch(onRejected);
        }
    }
}


export default {
    execute({url, method = 'GET', data = {}, isText = false, contentType = 'application/json'}) {
        const options = {
            method: method,
            headers: {
                'Accept': 'application/json',
                'Accept-Language': localStorage.getItem('lang') || 'ka',
                'extCustomerId': getExtCustomerId(),
            },
            credentials: 'include',
        };

        if (contentType) {
            options.headers['Content-Type'] = contentType;
        }

        if (method !== 'GET') {
            if (contentType !== 'application/json') {
                options.body = data;
            } else {
                options.body = JSON.stringify(data);
            }
        }

        return new ApiPromise((resolve, reject, signal) => {
            options.signal = signal;
            return fetch(config.apiEndpoint + url.replace(/^\/\/$/g, ''), options).then((res) => {
                if (!res.ok && res.status === 401) {
                    localStorage.removeItem('loggedIn');
                    reject(res);
                }
                if (!res.ok) {
                    res.json().then((json) => {
                        if (json) {
                            json.errorResponse = res;
                        }
                        reject(json);
                    });
                } else {
                    if (isText) {
                        return res.text().then((text) => {
                            resolve({
                                headers: res.headers,
                                status: res.status,
                                text,
                            });
                        });
                    }
                    return res.json().then((json) => {
                        resolve({
                            headers: res.headers,
                            status: res.status,
                            json,
                        });
                    });
                }
            }).catch((err) => {
                reject(err);
            });
        });
    },

    downloadBlob(url) {
        const options = {
            method: 'GET',
            headers: {
                'Accept-Language': localStorage.getItem('lang') || 'ka',
                'extCustomerId': getExtCustomerId(),
            },
            credentials: 'include',
        };
        return fetch(config.apiEndpoint + url.replace(/^\/\/$/g, ''), options).then((res) => {
            return res.blob();
        }).catch((err) => {
            return Promise.reject(err);
        });
    },
};
